/**
 * Admin-API: Sales Leads/Kunden (Akquise + Service)
 */

function authHeaders(token) {
  return { Authorization: "Bearer " + (token || "") };
}

export async function fetchAcquisition({ apiBase, token }) {
  const r = await fetch(`${apiBase}/api/admin/members-customers?status=akquise`, {
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Laden fehlgeschlagen");
  return Array.isArray(j.customers) ? j.customers : [];
}

export async function fetchService({ apiBase, token }) {
  const r = await fetch(`${apiBase}/api/admin/members-customers?status=service`, {
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Laden fehlgeschlagen");
  return Array.isArray(j.customers) ? j.customers : [];
}

export async function saveCustomer({ apiBase, token, id, payload }) {
  const isEdit = id != null;
  const r = await fetch(
    isEdit
      ? `${apiBase}/api/admin/members-customers/${id}`
      : `${apiBase}/api/admin/members-customers`,
    {
      method: isEdit ? "PUT" : "POST",
      headers: { "Content-Type": "application/json", ...authHeaders(token) },
      body: JSON.stringify(payload),
    },
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Speichern fehlgeschlagen");
  return j;
}

export async function fetchHistory({ apiBase, token, customerId }) {
  const r = await fetch(
    `${apiBase}/api/admin/members-customers/${customerId}/history`,
    { headers: authHeaders(token) },
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Historie konnte nicht geladen werden");
  return {
    customer: j.customer || null,
    history: Array.isArray(j.history) ? j.history : [],
  };
}

export async function sendAppUrl({ apiBase, token, customerId }) {
  const r = await fetch(
    `${apiBase}/api/admin/members-customers/${customerId}/send-app-url`,
    { method: "POST", headers: authHeaders(token) },
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "SMS konnte nicht gesendet werden");
  return j;
}

export async function sendAppointmentSms({ apiBase, token, customerId, body }) {
  const r = await fetch(
    `${apiBase}/api/admin/members-customers/${customerId}/send-appointment-sms`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders(token) },
      body: JSON.stringify({ body }),
    },
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "SMS konnte nicht gesendet werden");
  return j;
}
